import { FilterState } from '@Component/Filter/utils';
import { ColumnType } from '@Hooks/useOrdering';
import { AUTH_LEVEL_DEPARTMENT, useTskContext } from '@Hooks/useTskContext';
import { EmployeeOverviewTab } from '@Page/EmployeeOverview/EmployeeOverview';
import { getTabColumnKey, useGetColumns } from '@Page/EmployeeOverview/EmployeeOverviewColumnSettings';
import { useTableColumnsSetting } from '@tlx/astro-shared';
import { useIntl } from 'react-intl';

export function useTableColumnsSettingTabs(filters: FilterState): ColumnType[] {
    const intl = useIntl();

    const { hasDepartment, showDepartmentIsEmployeeAdmin, authLevelEmployeeOrWage } = useTskContext();

    const showDepartment =
        filters.viewFilter.query == 'salary' || filters.viewFilter.query == 'taxcard'
            ? showDepartmentIsEmployeeAdmin
            : hasDepartment;

    const allColumns = useGetColumns(
        intl,
        showDepartment,
        filters.viewFilter.query as EmployeeOverviewTab,
        authLevelEmployeeOrWage,
    );

    const defaultColumns = allColumns.filter((column) => !column.defaultDisabled);

    const columnIds = useTableColumnsSetting(
        getTabColumnKey(filters.viewFilter.query as EmployeeOverviewTab),
        defaultColumns.map((column) => column.id),
    );

    const columns = allColumns
        .filter((column) => columnIds.includes(column.id))
        .sort((a, b) => columnIds.indexOf(a.id) - columnIds.indexOf(b.id));
    //in case they are stored in local storage
    function removeExcludedColumns(columns: ColumnType[]): ColumnType[] {
        const columnsToExclude = ['hourlyRate', 'hourlyCost', 'dateOfBirth'];
        return columns.filter((column) => !columnsToExclude.includes(column.id));
    }

    if (authLevelEmployeeOrWage <= AUTH_LEVEL_DEPARTMENT) {
        removeExcludedColumns(columns);
    }

    return columns;
}
